<div class="msf-form-builder flex flex-column">

  <ng-template #fieldTemplate let-fieldsT="fieldsT" let-inline="inline">
    <div class="flex {{flexDirectionOptions}} w-full">
      @for (field of fieldsT; track field.name) {
        @if (!field.hide || !field.hide()) {
          <div
            class="field-group {{flexDirection === 'row' ? getCol(field, fieldsT, $index) : ''}}"
            [class.field-group--disabled]="isFieldDisabled(field)">
            @if (field.type !== 'checkbox') {
              <div class="field-label">
                <label>
                  {{ $any(field.title) | translate }}
                  @if (field.required) {
                    <span class="required-star">*</span>
                  }
                </label>
              </div>
            }
            @switch (field.type) {
              @case ('input') {
                <app-input
                  [(ngModel)]="model[field.name]"
                  type="text"
                  [placeholder]="getPlaceholder(field) | translate"
                  [disabled]="isFieldDisabled(field)"
                  (ngModelChange)="modelChange.emit(model)"
                  style="width: 100%"
                />
              }
              @case ('input-group') {
                <p-inputgroup>
                  @if (field.options.inputGroup?.iconLeft) {
                    <p-button
                      [icon]="field.options.inputGroup?.iconLeft"
                      severity="secondary"
                      variant="text"
                      [disabled]="isFieldDisabled(field)"
                      (click)="field.options.inputGroup?.actionLeft()"
                    />
                  }
                  <input
                    pInputText
                    type="text"
                    style="width: 100%"
                    [type]="'number'"
                    [(ngModel)]="model[field.name]"
                    [placeholder]="getPlaceholder(field) | translate"
                    [disabled]="isFieldDisabled(field)"
                    (ngModelChange)="modelChange.emit(model)"
                    (input)="limitDecimals($event, field.name)"
                  />
                  @if (field.options.inputGroup?.iconRight) {
                    <p-inputgroup-addon>
                      <p-button
                        [icon]="field.options.inputGroup?.iconRight"
                        severity="secondary"
                        variant="text"
                        [disabled]="isFieldDisabled(field)"
                        (click)="field.options.inputGroup?.actionRight()"
                      />
                    </p-inputgroup-addon>
                  }
                </p-inputgroup>
              }
              @case ('input-number') {
                <app-input
                  [(ngModel)]="model[field.name]"
                  type="number"
                  [placeholder]="getPlaceholder(field) | translate"
                  [disabled]="isFieldDisabled(field)"
                  (ngModelChange)="modelChange.emit(model)"
                  style="width: 100%"
                />
              }
              @case ('input-double') {
                <app-input
                  [(ngModel)]="model[field.name]"
                  type="double"
                  [placeholder]="getPlaceholder(field) | translate"
                  [disabled]="isFieldDisabled(field)"
                  (ngModelChange)="modelChange.emit(model)"
                  style="width: 100%"
                />
              }
              @case ('textarea') {
                <app-textarea
                  class="w-full"
                  [placeholder]="getPlaceholder(field) | translate"
                  [(ngModel)]="model[field.name]"
                  (ngModelChange)="modelChange.emit(model)"
                ></app-textarea>
              }
              @case ('select') {
                @if (field.metaField) {
                  <!-- Select поле с метаданными -->
                  <msf-select
                    [(model)]="model[field.name]"
                    [options]="getSelectOptionsFromMeta(field)"
                    [placeholder]="getPlaceholder(field) | translate"
                    [showClear]="getClear(field)"
                    [optionLabel]="'label'"
                    [externalLoading]="field?.options?.isLoading"
                    (modelChange)="modelChange.emit(model)"
                  />
                } @else if (field.getSelectOptions) {
                  <!-- Select поле с динамическими опциями -->
                  <msf-select
                    [(model)]="model[field.name]"
                    [service]="field.selectService"
                    serviceMethod="{{field.selectServiceMethod}}"
                    [options]="field.selectOptions || field.getSelectOptions()"
                    [placeholder]="getPlaceholder(field) | translate"
                    [showClear]="getClear(field)"
                    [optionLabel]="field.options?.select?.optionLabel || 'label'"
                    [optionValue]="field.options?.select?.optionValue || 'id'"
                    [optionSubtitle]="field.options?.select?.optionSubtitle"
                    [optionSubtitleJoiner]="field.options?.select?.optionSubtitleJoiner"
                    [translateBy]="field.options?.select?.translateBy || 'names'"
                    [isUser]="field.options?.select?.isUser"
                    [externalLoading]="field.options?.select?.loading"
                    (modelChange)="modelChange.emit(model)"

                  />
                } @else {
                  <!-- Обычное select поле -->
                  <msf-select
                    [(model)]="model[field.name]"
                    [service]="field.selectService"
                    serviceMethod="{{field.selectServiceMethod}}"
                    [options]="field.selectOptions"
                    [filter]="field.filter"
                    [placeholder]="getPlaceholder(field) | translate"
                    [showClear]="getClear(field)"
                    [externalLoading]="field.options?.select?.loading"
                    [loading]="field?.options?.isLoading"
                    [optionLabel]="field.options?.select?.optionLabel || 'label'"
                    [optionValue]="field.options?.select?.optionValue || 'id'"
                    [optionSubtitle]="field.options?.select?.optionSubtitle"
                    [optionSubtitleJoiner]="field.options?.select?.optionSubtitleJoiner"
                    [translateBy]="field.options?.select?.translateBy || 'names'"
                    [isUser]="field.options?.select?.isUser"
                    (modelChange)="modelChange.emit(model)"

                  />
                }
              }
              @case ('multi-select') {
                <msf-multi-select
                  [ngModel]="model[field.name]"
                  (ngModelChange)="model[field.name] = $event; modelChange.emit(model)"
                  [options]="field.selectOptions"
                  [placeholder]="getPlaceholder(field) | translate"
                  [showClear]="getClear(field)"
                  [optionLabel]="field.options?.select?.optionLabel || 'label'"
                  [optionValue]="field.options?.select?.optionValue || 'id'"
                  [translateBy]="field.options?.select?.translateBy || 'names'"
                />
              }
              @case ('select-paginate') {
                <msf-select-paginated
                  [showClear]="true"
                  [(model)]="model[field.name]"
                  [service]="field.selectService"
                  [disabled]="isFieldDisabled(field)"
                  (modelChange)="modelChange.emit(model)"
                  [placeholder]="getPlaceholder(field) | translate"
                  [optionLabel]="field.options?.select?.optionLabel || 'label'"
                  [optionSubtitle]="field.options?.select?.optionSubtitle"
                  [optionValue]="field.options?.select?.optionValue || 'id'"
                  [translateBy]="field.options?.select?.translateBy || 'names'"
                  [searchBy]="field.options?.select?.searchBy"
                  [searchKeywords]="field.options?.select?.searchKeywords"
                  serviceMethod="{{field.selectServiceMethod}}"
                  [filter]="field.options?.select?.filter || []"
                  [reload]="field._reloadToken"
                >
                </msf-select-paginated>
              }
              @case ('tree-select') {
                @if (field.metaField) {
                  <!-- Tree Select поле с метаданными -->
                  <msf-tree-select
                    [(model)]="model[field.name]"
                    [options]="getSelectOptionsFromMeta(field)"
                    [placeholder]="getPlaceholder(field) | translate"
                    [showClear]="getClear(field)"
                    [optionLabel]="field.options?.treeSelect?.optionLabel || 'name'"
                    [optionValue]="field.options?.treeSelect?.optionValue || 'id'"
                    [translateBy]="field.options?.treeSelect?.translateBy || 'names'"
                    [treeBy]="field.options?.treeSelect?.treeBy || 'parentId'"
                    (modelChange)="modelChange.emit(model)"

                />
                } @else if (field.getSelectOptions) {
                  <!-- Tree Select поле с динамическими опциями -->
                  <msf-tree-select
                    [(model)]="model[field.name]"
                    [service]="field.selectService"
                    serviceMethod="{{field.selectServiceMethod}}"
                    [options]="field.selectOptions || field.getSelectOptions()"
                    [placeholder]="getPlaceholder(field) | translate"
                    [showClear]="getClear(field)"
                    [optionLabel]="field.options?.treeSelect?.optionLabel || 'label'"
                    [optionValue]="field.options?.treeSelect?.optionValue || 'id'"
                    [translateBy]="field.options?.treeSelect?.translateBy || 'names'"
                    [treeBy]="field.options?.treeSelect?.treeBy || 'parentId'"
                    (modelChange)="modelChange.emit(model)"

                />
                } @else {
                  <!-- Обычное tree select  -->
                  <msf-tree-select
                    [(model)]="model[field.name]"
                    [service]="field.selectService"
                    [filter]="field.filter"
                    serviceMethod="{{field.selectServiceMethod}}"
                    [options]="field.selectOptions"
                    [placeholder]="getPlaceholder(field) | translate"
                    [showClear]="getClear(field)"
                    [optionLabel]="field.options?.treeSelect?.optionLabel || 'label'"
                    [optionValue]="field.options?.treeSelect?.optionValue || 'id'"
                    [translateBy]="field.options?.treeSelect?.translateBy || 'names'"
                    [treeBy]="field.options?.treeSelect?.treeBy || 'parentId'"
                    (modelChange)="modelChange.emit(model)"
                />
                }
              }
              @case ('checkbox') {
                <div class="checkbox-wrapper">
                  <app-checkbox
                    [(ngModel)]="model[field.name]"
                    [label]="field.title">
                  </app-checkbox>
                </div>
              }
              @case ('radio-box') {
                <app-radio-box
                  [(ngModel)]="model[field.name]"
                  [allLabel]="field.options?.radioBox?.allLabel || 'All'"
                  [yesLabel]="field.options?.radioBox?.yesLabel || 'Yes'"
                  [noLabel]="field.options?.radioBox?.noLabel || 'No'"
                  [showAll]="field.options?.radioBox?.showAll !== false"
                  [showYes]="field.options?.radioBox?.showYes !== false"
                  [showNo]="field.options?.radioBox?.showNo !== false"
                  [direction]="field.options?.radioBox?.direction || 'horizontal'"
                  (ngModelChange)="modelChange.emit(model)">
                </app-radio-box>
              }
              @case ('date') {
                <app-date-picker
                  [placeholder]="getPlaceholder(field) | translate"
                  [(ngModel)]="model[field.name]"
                  [firstDayOfWeek]="0"
                  [selectionMode]="field?.options?.date?.selectionMode || 'single'"
                  [showTime]="field?.options?.date?.showTime || false"
                  [showSeconds]="field?.options?.date?.showSeconds || false"
                  [dateOnly]="field?.options?.date?.dateOnly || false"
                  [yearOnly]="field?.options?.date?.yearOnly || false"
                  [dayOnly]="field?.options?.date?.dayOnly || false"
                  [monthOnly]="field?.options?.date?.monthOnly || false"
                  [monthAndDayOnly]="field?.options?.date?.monthAndDayOnly || false"
                  [allowOnlySelectedDate]="field?.options?.date?.allowOnlySelectedDate || false"
                  [selectableDates]="getDatePickerSelectableDates(field)"
                  [minDate]="field?.options?.date?.minDate || null"
                  [maxDate]="field?.options?.date?.maxDate || null"
                  [showClear]="getClear(field)"
                  (onYearChange)="onDatePickerYearChanger(field, $event)"
                  (onMonthChange)="onDatePickerMonthChanger(field, $event)"
                  (ngModelChange)="modelChange.emit(model)"

                ></app-date-picker>
              }
              @case ('inline-input') {
                <div class="flex flex-row w-full gap-2">
                  <ng-container
                    *ngTemplateOutlet="fieldTemplate; context: {  fieldsT: field.options.inlineInput , inline:true }"></ng-container>
                </div>
              }
              @case ('fileUpload') {
                <app-document-file-upload
                  [fileStorageId]="model[field.name]"
                  (fileSelected)="onFileSelected($event, field.name)"
                  (fileRemoved)="onFileRemoved(field.name)"
                />
              }
              @default {
                Default form.
              }
            }
          </div>
        }
      }
    </div>
  </ng-template>

  <ng-container *ngTemplateOutlet="fieldTemplate; context: {  fieldsT: fields }"></ng-container>
</div>
